import React, { Component } from "react";
import { Surface, Shape, Path } from "react-art";
import QRCode from "qrcode.react";
import "./Report.css";
import _ from "lodash";
import Api from "../../api/api";
import { intercept } from "mobx";
import intl from 'react-intl-universal';
import Apiwx from '../../api/wxapi';
import '../person/config'

import { inject, observer } from 'mobx-react';





@inject('store')
@observer
export default class ReportCar extends Component {
    constructor(props) {
        super();
        this.state = {
            report: null,
            language: 'zh',
            tyreunit: 'unit_mm',
        };


    }
    componentDidMount() {
        this.getRecordDetail();
        let lang = this.getQueryString('lang');
        intl.options.currentLocale = lang ? lang : 'zh'
        this.forceUpdate()

    }

    render() {
        if (this.state.report) {
            var {
                brake_type,
                car,
                plate_no,
                device_time,
                odometer,
                store,
                store_address,
                model_name,
                conclusion,
                suggestion,
                wear_lf_degree,
                wear_rf_degree,
                wear_lb_degree,
                wear_rb_degree,
                ecc_wear_lf_degree,
                ecc_wear_rf_degree,
                ecc_wear_lb_degree,
                ecc_wear_rb_degree,
                transposition,
                wear_threshold,
                wear_lf_data,
                wear_rf_data,
                wear_lb_data,
                wear_rb_data,
                wear_coordinate_max,
                wear_threshold,
                purpose,
                remark,
                tyre_lb,
                tyre_lf,
                tyre_rb,
                tyre_rf,
                uuid,
                trauma_lf_img,
                trauma_rf_img,
                trauma_lb_img,
                trauma_rb_img,
                language,
                last_wear,
                inspector,//技师名字
                inspector_number,
                wear_lf_value,
                wear_lb_value,
                wear_rf_value,
                wear_rb_value,
                logo,
                model_number,   //cormach.tyrescan.ts004
                create_time,
                positions,
                tires,
                genre,
                name,
                tyreunit
            } = this.state.report;
            this.state.tyreunit=tyreunit;
        }

        let lang = intl.options.currentLocale
        let param = tires ? this.dealpostion(tires,car.positions) : null
        let type = '-'
        if (car && car.genre == 'truck') {
            type = (lang=='zh'? car.name:car.en_name) +  (car.name!=='四轮位'? '-' + intl.get('txt_tuoche'):'')
        } else if (car && car.genre == 'mount') {
            if(lang==='zh')
              {type = car.name +(car.name!=='四轮位'? '-' + intl.get('txt_guache'):'') }
            else 
              {type = car.en_name +(car.name!=='四轮位'? '-' + intl.get('txt_guache'):'') }
            
        }
        return (
            <div className="report">
                {(this.state.report && lang !== 'zh_TW') && (
                    <div>
                        {/* 顶部信息 */}
                        <div className="report-item">
                            <div className="report-item-head">
                                <div style={{ marginBottom: 8 }}>
                                    <img
                                        src={logo ? logo : require('../../assets/logo.png')}
                                        alt=""
                                        style={{ width: 190, height: 51, objectFit: "fill" }}
                                    />

                                </div>
                            </div>
                            <div
                                className="report-head-info"
                                style={{ paddingLeft: 10, paddingRight: 10 }}>
                                <div style={{ width: "60%" }}>
                                    <div className="report-head-info__item1">
                                        <div className={lang == 'en' ? "rightspan" : "tit"} >{intl.get('txt_cphm') + ':'}</div>
                                        <span className="cnt">{plate_no.toUpperCase()}</span>
                                    </div>
                                    <div className="report-head-info__item1">
                                        <div className={lang == 'en' ? "rightspan" : "tit"}>{intl.get('txt_jcsj') + ':'}</div>
                                        <span className="cnt">

                                            {this.getTimeShow(device_time)}
                                        </span>
                                    </div>

                                    <div className="report-head-info__item1">
                                        <div className={lang == 'en' ? "rightspan" : "tit"}>{intl.get('txt_chexlw') + ':'}</div>
                                        <span className="cnt">{type}</span>
                                    </div>
                                    <div className="report-head-info__item1">
                                        <div className={lang == 'en' ? "rightspan" : "tit"}>{intl.get('txt_jiancerenyuan') + ':'}</div>
                                        <span className="cnt">{inspector ? inspector : "-"}</span>
                                    </div>
                                </div>

                            </div>
                        </div>
                        {/* 检测建议 */}
                        <div className="report-item section-2">
                            <div className="report-item-head">
                                <h2 className="tit">{intl.get('txt_jcjyi')}</h2>
                            </div>
                            <div className="report-item-main">
                                <p style={{ fontSize: 14, marginTop: 10 }}>  {this.getSuggestion(param)}</p>
                            </div>
                        </div>

                        {/* 整体磨损 */}
                        <div className="report-item-ztms section-4">
                            <div className="report-item-head">
                                <h2 className="tit">{intl.get('txt_ztms')}</h2>
                            </div>
                            {this.getRemindView(tyreunit)}

                            <div style={{ position: "relative", marginTop: 30, background: '#f7f7f7' }}>

                                <div style={{ display: "flex", flexDirection: 'column', justifyContent: 'center', alignItems: 'center', flexShrink: 0, background: 'white', paddingBottom: 30 }}>

                                    <div style={{ position: 'relative' }}>
                                        <div style={{ position: 'relative', paddingRight: 30, paddingLeft: 10, paddingTop: 40, paddingBottom: 40 }}>
                                            <div style={{ position: 'absolute', left: '10%', top: 0 }}>{intl.get('txt_right')}</div>
                                            <div style={{ position: 'absolute', left: '10%', top: 180 }}>{intl.get('txt_left')}</div>
                                            <img

                                                style={{
                                                    position: "relative",
                                                    width: 325,
                                                    height: 120,
                                                    objectFit: "contain",
                                                    zIndex: 10,

                                                }}
                                                src={car && car.genre == 'truck' ? require('../../assets/report/Last time_Model_tuo.png') : require("../../assets/report/Last time_Model_gua.png")}
                                                alt=""
                                            />
                                            {this.drawTire(param,car.genre)}
                                        </div>

                                    </div>

                                </div>
                                <div style={{ position: "relative", marginTop: 20, background: 'white' }}>
                                    {this.drawView(param,car.genre)}
                                </div>
                            </div>


                        </div>

                        <div>
                            <img style={{ width: "100%", height: 100 }}
                                resizemode="contain"
                                src={intl.options.currentLocale == 'zh' ? require("../../assets/report/guanggao.png") : require("../../assets/report/guanggaoen.png")} ></img>

                        </div>

                    </div>
                )}

            </div>
        );
    }

    getRemindView(tyreunit) {
        return (
          <div className="report-ztms1">
            <img style={{ height: '32px', marginTop: '4px' }} src={require('../../assets/image/trunkbgt.png')}></img>
    
            {(<div style={{
              display: "flex", flexDirection: 'row', alignItems: 'center'
              , height: '32px', justifyContent: 'space-between', position: 'absolute', top: '4px', left: 10, right: 10,
              paddingLeft: 10, paddingRight: 10
            }}>
              <div style={{ lineHeight: 1, textAlign: 'center', color: "white", }}>
                <div>{intl.get('txt_replace')}</div>
          
              </div>

              <div style={{ lineHeight: 1, textAlign: 'center', color: "white" }}>
                <div>{intl.get('txt_GoodState')}</div>
              
              </div>
            </div>)}
          </div>
        )
      }

    getSuggestion(data) {
        let temp1 = ''
        let temp2 = ''
        let temp3 = ''
        let temp4 = ''
        let beitai = ''
        let text = ''
        data.map((qiao, index) => {
            qiao.map((item, number) => {
                if (item.wear_degree == 'high') {
                    if (index == 0) {
                        if (temp1.length > 0) {
                            temp1 = temp1 + '、' + item.number
                        } else {
                            temp1 = temp1 + item.number
                        }

                    }
                    if (index == 1) {
                        if (temp2.length > 0) {
                            temp2 = temp2 + '、' + item.number
                        } else {
                            temp2 = temp2 + item.number
                        }
                    }
                    if (index == 2) {
                        if (temp3.length > 0) {
                            temp3 = temp3 + '、' + item.number
                        } else {
                            temp3 = temp3 + item.number
                        }
                    }
                    if (index == 3) {
                        if (temp4.length > 0) {
                            temp4 = temp4 + '、' + item.number
                        } else {
                            temp4 = temp4 + item.number
                        }
                    }
                    if (index == 4) {
                        if (beitai.length > 0) {
                            beitai = beitai + '、' + item.number
                        } else {
                            beitai = beitai + item.number
                        }
                    }
                }
            })
        })
        if (temp1.length <= 0 && temp2.length <= 0 && temp3.length <= 0 && temp4.length <= 0 && beitai.length <= 0) {
            return intl.get('txt_wear_normal')
        } else {
            let text = ''
            if (temp1.length > 0) {
                text = text + 1 + intl.get('txt_qiao') + '(' + temp1 + ')'
            }

            if (temp2.length > 0) {
                if (text.length > 0) {
                    text = text + ',' + 2 + intl.get('txt_qiao') + '(' + temp2 + ')'
                } else {
                    text = text + 2 + intl.get('txt_qiao') + '(' + temp2 + ')'
                }
            }

            if (temp3.length > 0) {
                if (text.length > 0) {
                    text = text + ',' + 3 + intl.get('txt_qiao') + '(' + temp3 + ')'
                } else {
                    text = text + 3 + intl.get('txt_qiao') + '(' + temp3 + ')'
                }
            }

            if (temp4.length > 0) {
                if (text.length > 0) {
                    text = text + ',' + 4 + intl.get('txt_qiao') + '(' + temp4 + ')'
                } else {
                    text = text + 4 + intl.get('txt_qiao') + '(' + temp4 + ')'
                }
            }

            if (beitai.length > 0) {
                if (text.length > 0) {
                    text = text + ',' + intl.get('txt_beitai') + '(' + beitai + ')'
                } else {
                    text = text + intl.get('txt_beitai') + '(' + beitai + ')'
                }
            }

            return text + intl.get('txt_msyzljgh')
        }

    }


    drawView(param,genre) {
        let {
            model_number
        } = this.state.report

        return param.map((item, index) => {
            if (item.length > 0) {
                let temp = []
                if (item.length == 4) {
                    temp.push(item[0])
                    temp.push(item[3])
                    temp.push(item[1])
                    temp.push(item[2])
                } else {
                    temp = item
                }
                return (
                    <div style={{ position: 'relative', paddingLeft: 20, paddingRight: 20, marginTop: 20 }} key={'key' + index}>
                        <div style={{ fontSize: 18, textAlign: 'center', position: 'relative', top: 40, width: '100%' }}>{index == 4 ? intl.get('txt_beitai') : index + 1 + intl.get('txt_qiao')}</div>

                        {this.drawQiao(item,genre)}

                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                            {temp.map((itemsingle, index) => {
                                return (<div key={index} style={{ width: '45%', display: 'flex', flexDirection: 'row', justifyContent: index == 0 || index == 2 ? 'flex-start' : 'flex-end' }}  >
                                    {model_number == 'leader.tyrescan.ts008' ? this.drawimgleader(itemsingle, index) : this.drawimg(itemsingle, index)}
                                </div>)
                            })}
                        </div>
                        <div style={{ width: '100%', height: 1, background: '#000', marginTop: 10 }}></div>
                    </div>
                )
            }

        })
    }


    //绘制每一桥
    drawQiao(data,genre) {
        if (data.length == 2) {
            if (intl.options.currentLocale == 'zh') 
            return (
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', paddingTop: 20 }}>
                    <div style={{ position: 'relative', left: 50, fontSize: 18 }}>{data[0].number}</div>
                    <div style={{ position: 'relative', left: 36, top: -55, width: 36, textAlign: 'center' }}>{intl.get('txt_left')}</div>
                    <img style={{ width: 36, height: 90 }} src={data[0].wear_degree == 'low' ? require('../../assets/report/tire_green_shuzhi.png') : data[0].wear_degree == 'high' ? require('../../assets/report/tire_red_shuzhi.png') : require('../../assets/report/tire_gray_shuzhi.png')}></img>
                    <img src={require('../../assets/report/axle4.png')} style={{ width: 194, height: 17 }}></img>
                    <img style={{ width: 36, height: 90 }} src={data[1].wear_degree == 'low' ? require('../../assets/report/tire_green_shuzhi.png') : data[1].wear_degree == 'high' ? require('../../assets/report/tire_red_shuzhi.png') : require('../../assets/report/tire_gray_shuzhi.png')}></img>
                    <div style={{ position: 'relative', right: 36, top: -55, width: 36, textAlign: 'center' }}>{intl.get('txt_right')}</div>
                    <div style={{ position: 'relative', right: 50, fontSize: 18 }}>{data[1].number}</div>
                </div>
            )
            else
            return (
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', paddingTop: 20 }}>
                    <div style={{ position: 'relative', left: 56, fontSize: 18 }}>{data[0].number}</div>
                    <div style={{ position: 'relative', left: 36, top: -55, width: 36, textAlign: 'center' }}>{intl.get('txt_left')}</div>
                    <img style={{ width: 36, height: 90 }} src={data[0].wear_degree == 'low' ? require('../../assets/report/tire_green_shuzhi.png') : data[0].wear_degree == 'high' ? require('../../assets/report/tire_red_shuzhi.png') : require('../../assets/report/tire_gray_shuzhi.png')}></img>
                    <img src={require('../../assets/report/axle4.png')} style={{ width: 194, height: 17 }}></img>
                    <img style={{ width: 36, height: 90 }} src={data[1].wear_degree == 'low' ? require('../../assets/report/tire_green_shuzhi.png') : data[1].wear_degree == 'high' ? require('../../assets/report/tire_red_shuzhi.png') : require('../../assets/report/tire_gray_shuzhi.png')}></img>
                    <div style={{ position: 'relative', right: 36, top: -55, width: 36, textAlign: 'center' }}>{intl.get('txt_right')}</div>
                    <div style={{ position: 'relative', right: 56, fontSize: 18 }}>{data[1].number}</div>
                </div>
            )

        } else if (data.length == 4) {
            if (intl.options.currentLocale == 'zh') {
                return (
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', paddingTop: 20 }}>
                        <div style={{ position: 'relative', left: data[0].number > 9 ? 124 : 120, fontSize: 18, zIndex: 20 }}>{data[0].number}</div>
                        <div style={{ position: 'relative', left: data[1].number > 9 ? 156 : 152, fontSize: 18, zIndex: 20 }}>{data[1].number}</div>
                        <div style={{ position: 'relative', left: 118, top: -55, width: 40, textAlign: 'center' }}>{intl.get('txt_left')}</div>
                        <img style={{ width: 36, height: 90, position: 'relative', left: 72 }} src={data[0].wear_degree == 'low' ? require('../../assets/report/tire_green_shuzhi.png') : data[0].wear_degree == 'high' ? require('../../assets/report/tire_red_shuzhi.png') : require('../../assets/report/tire_gray_shuzhi.png')}></img>
                        <img style={{ width: 36, height: 90, marginLeft: 5, position: 'relative', left: 72 }} src={data[1].wear_degree == 'low' ? require('../../assets/report/tire_green_shuzhi.png') : data[1].wear_degree == 'high' ? require('../../assets/report/tire_red_shuzhi.png') : require('../../assets/report/tire_gray_shuzhi.png')}></img>
                        <img src={require('../../assets/report/axle5.png')} style={{ width: 280, height: 17 }}></img>
                        <img style={{ width: 36, height: 90, marginRight: 5, position: 'relative', right: 72 }} src={data[2].wear_degree == 'low' ? require('../../assets/report/tire_green_shuzhi.png') : data[2].wear_degree == 'high' ? require('../../assets/report/tire_red_shuzhi.png') : require('../../assets/report/tire_gray_shuzhi.png')}></img>
                        <img style={{ width: 36, height: 90, position: 'relative', right: 72 }} src={data[3].wear_degree == 'low' ? require('../../assets/report/tire_green_shuzhi.png') : data[3].wear_degree == 'high' ? require('../../assets/report/tire_red_shuzhi.png') : require('../../assets/report/tire_gray_shuzhi.png')}></img>
                        <div style={{ position: 'relative', right: 118, top: -55, width: 40, textAlign: 'center' }}>{intl.get('txt_right')}</div>
                        <div style={{ position: 'relative', right: data[2].number > 9 ? 152 : 148, fontSize: 18, zIndex: 20 }}>{data[2].number}</div>
                        <div style={{ position: 'relative', right: data[3].number > 9 ? 122 : 118, fontSize: 18, zIndex: 20 }}>{data[3].number}</div>
                    </div>
                )
            } else if (intl.options.currentLocale == 'en') {
                if(genre==='mount')
                return (
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', paddingTop: 20 }}>
                        <div style={{ position: 'relative', left: data[0].number > 9 ? 154 : 146, fontSize: 13, zIndex: 20 }}>{data[0].number}</div>
                        <div style={{ position: 'relative', left: data[1].number > 9 ? 168 : 162, fontSize: 13, zIndex: 20 }}>{data[1].number}</div>
                        <div style={{ position: 'relative', left: 122, top: -55, width: 36, textAlign: 'center' }}>{intl.get('txt_left')}</div>
                        <img style={{ width: 36, height: 90, position: 'relative', left: 72 }} src={data[0].wear_degree == 'low' ? require('../../assets/report/tire_green_shuzhi.png') : data[0].wear_degree == 'high' ? require('../../assets/report/tire_red_shuzhi.png') : require('../../assets/report/tire_gray_shuzhi.png')}></img>
                        <img style={{ width: 36, height: 90, marginLeft: 5, position: 'relative', left: 72 }} src={data[1].wear_degree == 'low' ? require('../../assets/report/tire_green_shuzhi.png') : data[1].wear_degree == 'high' ? require('../../assets/report/tire_red_shuzhi.png') : require('../../assets/report/tire_gray_shuzhi.png')}></img>
                        <img src={require('../../assets/report/axle5.png')} style={{ width: 280, height: 17 }}></img>
                        <img style={{ width: 36, height: 90, marginRight: 5, position: 'relative', right: 72 }} src={data[2].wear_degree == 'low' ? require('../../assets/report/tire_green_shuzhi.png') : data[2].wear_degree == 'high' ? require('../../assets/report/tire_red_shuzhi.png') : require('../../assets/report/tire_gray_shuzhi.png')}></img>
                        <img style={{ width: 36, height: 90, position: 'relative', right: 72 }} src={data[3].wear_degree == 'low' ? require('../../assets/report/tire_green_shuzhi.png') : data[3].wear_degree == 'high' ? require('../../assets/report/tire_red_shuzhi.png') : require('../../assets/report/tire_gray_shuzhi.png')}></img>
                        <div style={{ position: 'relative', right: 122, top: -55, width: 36, textAlign: 'center' }}>{intl.get('txt_right')}</div>
                        <div style={{ position: 'relative', right: data[2].number > 9 ? 180 : 174, fontSize: 13, zIndex: 20 }}>{data[2].number}</div>
                        <div style={{ position: 'relative', right: data[3].number > 9 ? 160 : 154, fontSize: 13, zIndex: 20 }}>{data[3].number}</div>
                    </div>)
                else
                  return (
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', paddingTop: 20 }}>
                        <div style={{ position: 'relative', left: data[0].number > 9 ? 134 : 130, fontSize: 18, zIndex: 20 }}>{data[0].number}</div>
                        <div style={{ position: 'relative', left: data[1].number > 9 ? 164 : 160, fontSize: 18, zIndex: 20 }}>{data[1].number}</div>
                        <div style={{ position: 'relative', left: 122, top: -55, width: 36, textAlign: 'center' }}>{intl.get('txt_left')}</div>
                        <img style={{ width: 36, height: 90, position: 'relative', left: 72 }} src={data[0].wear_degree == 'low' ? require('../../assets/report/tire_green_shuzhi.png') : data[0].wear_degree == 'high' ? require('../../assets/report/tire_red_shuzhi.png') : require('../../assets/report/tire_gray_shuzhi.png')}></img>
                        <img style={{ width: 36, height: 90, marginLeft: 5, position: 'relative', left: 72 }} src={data[1].wear_degree == 'low' ? require('../../assets/report/tire_green_shuzhi.png') : data[1].wear_degree == 'high' ? require('../../assets/report/tire_red_shuzhi.png') : require('../../assets/report/tire_gray_shuzhi.png')}></img>
                        <img src={require('../../assets/report/axle5.png')} style={{ width: 280, height: 17 }}></img>
                        <img style={{ width: 36, height: 90, marginRight: 5, position: 'relative', right: 72 }} src={data[2].wear_degree == 'low' ? require('../../assets/report/tire_green_shuzhi.png') : data[2].wear_degree == 'high' ? require('../../assets/report/tire_red_shuzhi.png') : require('../../assets/report/tire_gray_shuzhi.png')}></img>
                        <img style={{ width: 36, height: 90, position: 'relative', right: 72 }} src={data[3].wear_degree == 'low' ? require('../../assets/report/tire_green_shuzhi.png') : data[3].wear_degree == 'high' ? require('../../assets/report/tire_red_shuzhi.png') : require('../../assets/report/tire_gray_shuzhi.png')}></img>
                        <div style={{ position: 'relative', right: 122, top: -55, width: 36, textAlign: 'center' }}>{intl.get('txt_right')}</div>
                        <div style={{ position: 'relative', right: data[2].number > 9 ? 172 : 168, fontSize: 18, zIndex: 20 }}>{data[2].number}</div>
                        <div style={{ position: 'relative', right: data[3].number > 9 ? 140 : 136, fontSize: 18, zIndex: 20 }}>{data[3].number}</div>
                    </div>
                )
            } else {
                return (
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', paddingTop: 20 }}>
                        <div style={{ position: 'relative', left: data[0].number > 9 ? 150 : 146, fontSize: 18, zIndex: 20 }}>{data[0].number}</div>
                        <div style={{ position: 'relative', left: data[1].number > 9 ? 178 : 176, fontSize: 18, zIndex: 20 }}>{data[1].number}</div>
                        <div style={{ position: 'relative', left: 126, top: -55, width: 40, textAlign: 'center' }}>{intl.get('txt_left')}</div>
                        <img style={{ width: 36, height: 90, position: 'relative', left: 72 }} src={data[0].wear_degree == 'low' ? require('../../assets/report/tire_green_shuzhi.png') : data[0].wear_degree == 'high' ? require('../../assets/report/tire_red_shuzhi.png') : require('../../assets/report/tire_gray_shuzhi.png')}></img>
                        <img style={{ width: 36, height: 90, marginLeft: 5, position: 'relative', left: 72 }} src={data[1].wear_degree == 'low' ? require('../../assets/report/tire_green_shuzhi.png') : data[1].wear_degree == 'high' ? require('../../assets/report/tire_red_shuzhi.png') : require('../../assets/report/tire_gray_shuzhi.png')}></img>
                        <img src={require('../../assets/report/axle5.png')} style={{ width: 280, height: 17 }}></img>
                        <img style={{ width: 36, height: 90, marginRight: 5, position: 'relative', right: 72 }} src={data[2].wear_degree == 'low' ? require('../../assets/report/tire_green_shuzhi.png') : data[2].wear_degree == 'high' ? require('../../assets/report/tire_red_shuzhi.png') : require('../../assets/report/tire_gray_shuzhi.png')}></img>
                        <img style={{ width: 36, height: 90, position: 'relative', right: 72 }} src={data[3].wear_degree == 'low' ? require('../../assets/report/tire_green_shuzhi.png') : data[3].wear_degree == 'high' ? require('../../assets/report/tire_red_shuzhi.png') : require('../../assets/report/tire_gray_shuzhi.png')}></img>
                        <div style={{ position: 'relative', right: 126, top: -55, width: 40, textAlign: 'center' }}>{intl.get('txt_right')}</div>
                        <div style={{ position: 'relative', right: data[2].number > 9 ? 176 : 172, fontSize: 18, zIndex: 20 }}>{data[2].number}</div>
                        <div style={{ position: 'relative', right: data[3].number > 9 ? 146 : 142, fontSize: 18, zIndex: 20 }}>{data[3].number}</div>
                    </div>
                )
            }

        }
    }

    returnTyrePoint(data) {
        let _obj = [];
        let _newObj = [];
        if (data) {
            _obj = _.chunk(data, 4);
            _obj = _obj.map(item => {
                _newObj.push(item[1]);
            });
            if(this.state.tyreunit=='unit_in')
              _newObj = _newObj.map(item => _.toNumber((item / 10 * 1.25984).toFixed(1)));
            else
             _newObj = _newObj.map(item => _.toNumber((item / 10).toFixed(1)));
        }
        return _newObj;
    };

    getAverage(arr) {
        console.log('arr=' + arr)
        if (arr.length <= 0) {
            return 0
        } else if (arr.length > 0 && arr.length <= 2) {
            let total = 0
            arr.map(item => {
                total = total + item
            })
            let average = total / arr.length
            console.log('a=' + average)
            return average.toFixed(2);
        } else {
            let max = Math.max.apply(null, arr)
            let min = Math.min.apply(null, arr)
            let total = 0
            arr.map(item => {
                total = total + item
            })
            total = total - max - min
            let average = total / (arr.length - 2)
            console.log('a=' + average + 'max=' + max + 'min=' + min)
            return average.toFixed(2);
        }


    }

    //绘画每个轮子的详细数据-leader.tyrescan.ts008
    drawimgleader(data, index) {
        let temp1 = data.wear_data ? data.wear_data.split(",") : null
        let status = data.wear_degree//程度
        let _data;
        let points = this.returnTyrePoint(temp1)
        let lang = intl.options.currentLocale
        let average = this.getAverage(points)
        return (
            <div style={{ width: '100%', paddingTop: 20, paddingLeft: 20, paddingRight: 20 }}>
                {(index == 0 || index == 2) && (
                    <div>
                        {status && status !== '' && (<div style={{ display: 'flex', flexDirection: 'column', alignItems: "flex-start" }}>
                            <div style={{ position: 'relative', top: -10, right: index == 0 ? 10 : '-90%', color: 'white', background: data.wear_degree == 'low' ? usercolors[0] : data.wear_degree == 'high' ? usercolors[2] : '#a4a4a4', width: 20, textAlign: "center", borderRadius: 20, }}>{data.number}</div>
                            <div style={{ color: status && status == 'low' ? usercolors[0] : usercolors[2] }}> {status && status == 'low' ? intl.get('txt_GoodState') : intl.get('txt_replace')}</div>
                            <div style={{ fontSize: 12 }}>{intl.get('txt_pingjunzhi')}:<span style={{ color: status && status == 'low' ? usercolors[0] : usercolors[2], fontSize: 14 }}>{average}</span> </div>
                        </div>)}
                        {(!status||status=='')&&<div>{intl.get('txt_NoData')}</div>}     
                    </div>)}
                {(index == 1 || index == 3) && (<div>
                    {status && status !== '' && (<div style={{ display: 'flex', flexDirection: 'column', alignItems: "flex-end" }}>
                        <div style={{ position: 'relative', top: -10, left: index == 1 ? 10 : '-90%', color: 'white', background: data.wear_degree == 'low' ? usercolors[0] : data.wear_degree == 'high' ? usercolors[2] : '#a4a4a4', width: 20, textAlign: "center", borderRadius: 20 }}>{data.number}</div>
                        <div style={{ color: status && status == 'low' ? usercolors[0] : usercolors[2] }}> {status && status == 'low' ? intl.get('txt_GoodState') : intl.get('txt_replace')}</div>
                        <div style={{ fontSize: 12 }}> <span style={{ color: status && status == 'low' ? usercolors[0] : usercolors[2], fontSize: 14 }}>{average}:</span>{intl.get('txt_pingjunzhi')} </div>
                    </div>)} 
                     {(!status||status=='')&&<div style={{position:'relative',left:20}}>{intl.get('txt_NoData')}</div>} 
                    </div>)}
            </div>
        )
    }
    //绘画每个轮子的详细数据
    drawimg(data, index) {
        let temp1 = data.wear_data ? data.wear_data.split(",") : null
        let status = data.wear_degree//程度
        let _data;
        let points = this.returnTyrePoint(temp1)
        let lang = intl.options.currentLocale

        if (!temp1) {
            _data = 1;
        } else {
            _data = temp1.length / 4;
        }
        if (status === "high") {
            return (
                <div style={{ width: '100%' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: 20, width: '100%' }} >


                        {_data > 6 && (
                            <img
                                className="tyre"
                                src={require("../../assets/report/tyre-red-6.png")}
                                alt=""
                            />
                        )}
                        {_data === 6 && (
                            <img
                                className="tyre"
                                src={require("../../assets/report/tyre-red-5.png")}
                                alt=""
                            />
                        )}
                        {_data === 5 && (
                            <img
                                className="tyre"
                                src={require("../../assets/report/tyre-red-4.png")}
                                alt=""
                            />
                        )}
                        {_data === 4 && (
                            <img
                                className="tyre"
                                src={require("../../assets/report/tyre-red-1.png")}
                                alt=""
                            />
                        )}
                        {_data === 3 && (
                            <img
                                className="tyre"
                                src={require("../../assets/report/tyre-red-2.png")}
                                alt=""
                            />
                        )}
                        {_data === 2 && (
                            <img
                                className="tyre"
                                src={require("../../assets/report/tyre-red-3.png")}
                                alt=""
                            />
                        )}
                        {_data <= 1 && (
                            <img
                                className="tyre"
                                src={require("../../assets/report/tyre-default.png")}
                                alt=""
                            />
                        )}
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                                width: points.length >= 5 ? points.length >= 7 ? 160 : 140 : 112,
                                marginTop: -8,
                                position: 'relative',
                                left: points.length >= 6 ? (index == 0 || index == 2) ? -12 : 5 : 0,
                                height: 20

                            }}

                        >   {points.map((point, index) => {

                            return (<span style={{ fontSize: points.length >= 6 ? "11px" : '12px' }} key={index}>
                                {point}
                            </span>)

                        })}</div>
                    </div>

                    {(index == 0 || index == 2) && lang == 'zh' && (<div>
                        <div style={{ position: 'relative', top: -70, right: index == 0 ? 10 : '-90%', color: 'white', background: data.wear_degree == 'low' ? usercolors[0] : data.wear_degree == 'high' ? usercolors[2] : '#a4a4a4', width: 20, textAlign: "center", borderRadius: 20, }}>{data.number}</div>
                        <div>{intl.get('txt_pinpai') + ':'} <span>{data.brand ? data.brand : '-'}</span>  </div>
                        <div>{intl.get('txt_guige') + ':'}<span>{data.spec ? data.spec : '-'}</span></div>
                        <div>{intl.get('txt_huawen') + ':'}<span>{data.pattern ? data.pattern : '-'}</span></div>
                        <div>{intl.get('txt_taihao') + ':'}<span>{data.code ? data.code : '-'}</span></div>
                        <div>{'DOT:'}<span>{data.dot ? data.dot : '-'}</span></div>
                        <div>{intl.get('txt_taiya') + ':'}<span>{+ data.pressure ? data.pressure : '-'}</span></div>
                        <div>{intl.get('txt_waishang') + ':'} {this.getWaishang(data.trauma)}</div>
                        {data.trauma_img && (<img
                            style={{
                                width: 90,
                                height: 60
                            }}
                            resizemode="contain"
                            src={data.trauma_img} />)}
                    </div>)}
                    {(index == 0 || index == 2) && lang !== 'zh' && (<div>
                        <div style={{ position: 'relative', top: -70, right: index == 0 ? 10 : '-90%', color: 'white', background: data.wear_degree == 'low' ? usercolors[0] : data.wear_degree == 'high' ? usercolors[2] : '#a4a4a4', width: 20, textAlign: "center", borderRadius: 20, }}>{data.number}</div>
                        <div>{'DOT:'}<span>{data.dot ? data.dot : '-'}</span></div>
                        <div>{intl.get('txt_pinpai') + ':'}   </div>
                        <div>{data.brand ? data.brand : '-'}</div>
                        <div>{intl.get('txt_guige') + ':'}</div>
                        <div>{data.spec ? data.spec : '-'}</div>
                        <div>{intl.get('txt_huawen') + ':'}</div>
                        <div>{data.pattern ? data.pattern : '-'}</div>
                        <div>{intl.get('txt_taihao') + ':'}</div>
                        <span>{data.code ? data.code : '-'}</span>
                        <div>{intl.get('txt_taiya') + ':'}</div>
                        <span>{+ data.pressure ? data.pressure : '-'}</span>
                        <div>{intl.get('txt_waishang') + ':'} {this.getWaishang(data.trauma)}</div>
                        {data.trauma_img && (<img
                            style={{
                                width: 90,
                                height: 60
                            }}
                            resizemode="contain"
                            src={data.trauma_img} />)}
                    </div>)}
                    {(index == 1 || index == 3) && lang == 'zh' && (<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
                        <div style={{ position: 'relative', top: -70, left: index == 1 ? 10 : '-90%', color: 'white', background: data.wear_degree == 'low' ? usercolors[0] : data.wear_degree == 'high' ? usercolors[2] : '#a4a4a4', width: 20, textAlign: "center", borderRadius: 20 }}>{data.number}</div>
                        <div><span>{data.brand ? data.brand : '-'}</span> {':' + intl.get('txt_pinpai')}</div>
                        <div><span>{data.spec ? data.spec : '-'}</span>{':' + intl.get('txt_guige')}</div>
                        <div><span>{data.pattern ? data.pattern : '-'}</span> {':' + intl.get('txt_huawen')}</div>
                        <div> <span>{data.code ? data.code : '-'}</span> {':' + intl.get('txt_taihao')}</div>
                        <div><span>{data.dot ? data.dot : '-'}</span>{':DOT'}</div>
                        <div> <span>{data.pressure ? data.pressure : '-'}</span>  {':' + intl.get('txt_taiya')}</div>
                        <div> {this.getWaishang(data.trauma)}{':' + intl.get('txt_waishang')} </div>
                        {data.trauma_img && (<img
                            style={{
                                width: 90,
                                height: 60
                            }}
                            resizemode="contain"
                            src={data.trauma_img} />)}
                    </div>)}
                    {(index == 1 || index == 3) && lang !== 'zh' && (<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
                        <div style={{ position: 'relative', top: -70, left: index == 1 ? 10 : '-90%', color: 'white', background: data.wear_degree == 'low' ? usercolors[0] : data.wear_degree == 'high' ? usercolors[2] : '#a4a4a4', width: 20, textAlign: "center", borderRadius: 20 }}>{data.number}</div>
                        <div>  <span>{data.dot ? data.dot : '-'}</span>{':DOT'}</div>
                        <div>{':' + intl.get('txt_pinpai')}</div>
                        <span>{data.brand ? data.brand : '-'}</span>
                        <div>{':' + intl.get('txt_guige')}</div>
                        <span>{data.spec ? data.spec : '-'}</span>
                        <div> {':' + intl.get('txt_huawen')}</div>
                        <span>{data.pattern ? data.pattern : '-'}</span>
                        <div>  {':' + intl.get('txt_taihao')}</div>
                        <span>{data.code ? data.code : '-'}</span>

                        <div> {':' + intl.get('txt_taiya')}</div>
                        <span>{data.pressure ? data.pressure : '-'}</span>
                        <div> {this.getWaishang(data.trauma)}{':' + intl.get('txt_waishang')} </div>
                        {data.trauma_img && (<img
                            style={{
                                width: 90,
                                height: 60
                            }}
                            resizemode="contain"
                            src={data.trauma_img} />)}
                    </div>)}
                </div>
            );
        } else {
            return (
                <div style={{ width: '100%' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: 20, width: '100%' }}>
                        {_data > 6 && (
                            <img
                                className="tyre"
                                src={require("../../assets/report/tyre-green-6.png")}
                                alt=""
                            />
                        )}
                        {_data === 6 && (
                            <img
                                className="tyre"
                                src={require("../../assets/report/tire-green-5.png")}
                                alt=""
                            />
                        )}
                        {_data === 5 && (
                            <img
                                className="tyre"
                                src={require("../../assets/report/tire-green-4.png")}
                                alt=""
                            />
                        )}
                        {_data === 4 && (
                            <img
                                className="tyre"
                                src={require("../../assets/report/tyre-green-1.png")}
                                alt=""
                            />
                        )}
                        {_data === 3 && (
                            <img
                                className="tyre"
                                src={require("../../assets/report/tyre-green-2.png")}
                                alt=""
                            />
                        )}
                        {_data === 2 && (
                            <img
                                className="tyre"
                                src={require("../../assets/report/tyre-green-3.png")}
                                alt=""
                            />
                        )}
                        {_data <= 1 && (
                            <img
                                className="tyre"
                                src={require("../../assets/report/tyre-default.png")}
                                alt=""
                            />
                        )}

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                                width: points.length >= 5 ? points.length >= 7 ? 160 : 140 : 112,
                                marginTop: -8,
                                position: 'relative',
                                left: points.length >= 6 ? (index == 0 || index == 2) ? -12 : 5 : 0,
                                height: 20,


                            }}

                        >   {points.map((point, index) => {

                            return (<span style={{ fontSize: points.length >= 6 ? '11px' : "12px", }} key={index}>
                                {point}
                            </span>)

                        })}</div>
                    </div>
                    {(index == 0 || index == 2) && lang == 'zh' && (<div>
                        <div style={{ position: 'relative', top: -70, right: index == 0 ? 10 : '-90%', color: 'white', background: data.wear_degree == 'low' ? usercolors[0] : data.wear_degree == 'high' ? usercolors[2] : '#a4a4a4', width: 20, textAlign: "center", borderRadius: 20 }}>{data.number}</div>
                        <div>{intl.get('txt_pinpai') + ':'} <span>{data.brand ? data.brand : '-'}</span>  </div>
                        <div>{intl.get('txt_guige') + ':'}<span>{data.spec ? data.spec : '-'}</span></div>
                        <div>{intl.get('txt_huawen') + ':'}<span>{data.pattern ? data.pattern : '-'}</span></div>
                        <div>{intl.get('txt_taihao') + ':'}<span>{data.code ? data.code : '-'}</span></div>
                        <div>{'DOT:'}<span>{data.dot ? data.dot : '-'}</span></div>
                        <div>{intl.get('txt_taiya') + ':'}<span>{+ data.pressure ? data.pressure : '-'}</span></div>
                        <div>{intl.get('txt_waishang') + ':'} {this.getWaishang(data.trauma)}</div>
                        {data.trauma_img && (<img
                            style={{
                                width: 90,
                                height: 60
                            }}
                            resizemode="contain"
                            src={data.trauma_img} />)}
                    </div>)}
                    {(index == 0 || index == 2) && lang !== 'zh' && (<div>
                        <div style={{ position: 'relative', top: -70, right: index == 0 ? 10 : '-90%', color: 'white', background: data.wear_degree == 'low' ? usercolors[0] : data.wear_degree == 'high' ? usercolors[2] : '#a4a4a4', width: 20, textAlign: "center", borderRadius: 20 }}>{data.number}</div>
                        <div>{'DOT:'}<span>{data.dot ? data.dot : '-'}</span></div>
                        <div>{intl.get('txt_pinpai') + ':'}  </div>
                        <span>{data.brand ? data.brand : '-'}</span>
                        <div>{intl.get('txt_guige') + ':'}</div>
                        <span>{data.spec ? data.spec : '-'}</span>
                        <div>{intl.get('txt_huawen') + ':'}</div>
                        <span>{data.pattern ? data.pattern : '-'}</span>
                        <div>{intl.get('txt_taihao') + ':'}</div>
                        <span>{data.code ? data.code : '-'}</span>

                        <div>{intl.get('txt_taiya') + ':'}</div>
                        <span>{+ data.pressure ? data.pressure : '-'}</span>
                        <div>{intl.get('txt_waishang') + ':'} {this.getWaishang(data.trauma)}</div>
                        {data.trauma_img && (<img
                            style={{
                                width: 90,
                                height: 60
                            }}
                            resizemode="contain"
                            src={data.trauma_img} />)}
                    </div>)}

                    {(index == 1 || index == 3) && lang == 'zh' && (<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
                        <div style={{ position: 'relative', top: -70, left: index == 1 ? 10 : '-90%', color: 'white', background: data.wear_degree == 'low' ? usercolors[0] : data.wear_degree == 'high' ? usercolors[2] : '#a4a4a4', width: 20, textAlign: "center", borderRadius: 20 }}>{data.number}</div>
                        <div><span>{data.brand ? data.brand : '-'}</span> {':' + intl.get('txt_pinpai')}</div>
                        <div><span>{data.spec ? data.spec : '-'}</span>{':' + intl.get('txt_guige')}</div>
                        <div><span>{data.pattern ? data.pattern : '-'}</span> {':' + intl.get('txt_huawen')}</div>
                        <div> <span>{data.code ? data.code : '-'}</span> {':' + intl.get('txt_taihao')}</div>
                        <div><span>{data.dot ? data.dot : '-'}</span>{':DOT'}</div>
                        <div> <span>{data.pressure ? data.pressure : '-'}</span>  {':' + intl.get('txt_taiya')}</div>
                        <div> {this.getWaishang(data.trauma)}{':' + intl.get('txt_waishang')} </div>
                        {data.trauma_img && (<img
                            style={{
                                width: 90,
                                height: 60
                            }}
                            resizemode="contain"
                            src={data.trauma_img} />)}
                    </div>)}
                    {(index == 1 || index == 3) && lang !== 'zh' && (<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
                        <div style={{ position: 'relative', top: -70, left: index == 1 ? 10 : '-90%', color: 'white', background: data.wear_degree == 'low' ? usercolors[0] : data.wear_degree == 'high' ? usercolors[2] : '#a4a4a4', width: 20, textAlign: "center", borderRadius: 20 }}>{data.number}</div>
                        <div><span>{data.dot ? data.dot : '-'}</span>{':DOT'}</div>
                        <div> {':' + intl.get('txt_pinpai')}</div>
                        <span>{data.brand ? data.brand : '-'}</span>
                        <div>{':' + intl.get('txt_guige')}</div>
                        <span>{data.spec ? data.spec : '-'}</span>
                        <div> {':' + intl.get('txt_huawen')}</div>
                        <span>{data.pattern ? data.pattern : '-'}</span>
                        <div>  {':' + intl.get('txt_taihao')}</div>
                        <span>{data.code ? data.code : '-'}</span>

                        <div> {':' + intl.get('txt_taiya')}</div>
                        <span>{data.pressure ? data.pressure : '-'}</span>
                        <div> {this.getWaishang(data.trauma)}{':' + intl.get('txt_waishang')} </div>
                        {data.trauma_img && (<img
                            style={{
                                width: 90,
                                height: 60
                            }}
                            resizemode="contain"
                            src={data.trauma_img} />)}
                    </div>)}
                </div>
            );
        }
    }

    getWaishang(data) {
        if (data.indexOf('trauma_normal') > -1) {
            return (<span style={{ color: usercolors[0] }}>{intl.get('txt_jianyineirongzc')}</span>)
        } else {
            let temptext = ''
            let tempArr = data.split(';')
            tempArr.map(item => {
                if (item == 'trauma_normal') {
                    temptext = temptext + intl.get('txt_zcd')

                } else if (item == 'trauma_bulge') {
                    temptext = temptext + ' ' + intl.get('txt_gubao')
                } else if (item == 'trauma_aging') {
                    temptext = temptext + ' ' + intl.get('txt_laohua')
                } else if (item == 'trauma_lacerate') {
                    temptext = temptext + ' ' + intl.get('txt_gelie')
                } else if (item == 'trauma_dropblock') {
                    temptext = temptext + ' ' + intl.get('txt_diaokuai')
                } else if (item == 'trauma_puncture') {
                    temptext = temptext + ' ' + intl.get('txt_chaungci')
                } else if (item == 'trauma_scratch') {
                    temptext = temptext + ' ' + intl.get('txt_cashang')
                } else if (item == 'trauma_pinnate') {
                    temptext = temptext + ' ' + intl.get('txt_pinnate_wear')
                }

            })
            let text = temptext;
            return (<span style={{ color: usercolors[2] }}>{text}</span>)
        }
    }

    dealpostion(tires,positions) {
        let temp1 = [];
        let temp2 = []
        let temp3 = []
        let temp4 = []
        let temp5 = []
        let lang = intl.options.currentLocale
        tires.map((item,index) => {
             item.number=(lang === 'zh')?item.number:positions[index].en_pos;
            if (item.position.indexOf('01') > -1) {
                temp1.push(item)
            }
            if (item.position.indexOf('02') > -1) {
                temp2.push(item)
            }
            if (item.position.indexOf('03') > -1) {
                temp3.push(item)
            }
            if (item.position.indexOf('04') > -1) {
                temp4.push(item)
            }
            if (item.position.indexOf('B') > -1) {
                temp5.push(item)
            }
        })

        let param = [temp1, temp2, temp3, temp4, temp5]

        return param
    }

    //根据不同情况调整样式
    dealStyle(param, styles, styles1) {
        let i = 0;
        param.map((item, index) => {
            if (index !== param.length - 1 && item.length > 0) {
                i++
            }
        })
        let top1 = 10
        let top2 = -28
        if (i < 2 || i > 3) {
            //对应一桥2个轮子  
            styles = [{ position: 'absolute', left: 60, top: top1 }, { position: 'absolute', left: 120, top: top1 }, { position: 'absolute', left: 180, top: top1 }, { position: 'absolute', left: 240, top: top1 }, { position: 'absolute', left: 300, top: top1 }]
            //对应一桥4个轮子
            styles1 = [{ position: 'absolute', left: 60, top: top2 }, { position: 'absolute', left: 120, top: top2 }, { position: 'absolute', left: 180, top: top2 }, { position: 'absolute', left: 240, top: top2 }, { position: 'absolute', left: 300, top: top2 }]
        } else if (i == 2) {
            //对应一桥2个轮子  
            styles = [{ position: 'absolute', left: 90, top: top1 }, { position: 'absolute', left: 225, top: top1 }, {}, {}, { position: 'absolute', left: 300, top: top1 }]
            //对应一桥4个轮子
            styles1 = [{ position: 'absolute', left: 90, top: top2 }, { position: 'absolute', left: 225, top: top2 }, { position: 'absolute', left: 300, top: top2 }]
        } else if (i == 3) {
            //对应一桥2个轮子  
            styles = [{ position: 'absolute', left: 80, top: top1 }, { position: 'absolute', left: 160, top: top1 }, { position: 'absolute', left: 240, top: top1 }, { position: 'absolute', left: 300, top: top1 }, { position: 'absolute', left: 300, top: top1 }]
            //对应一桥4个轮子
            styles1 = [{ position: 'absolute', left: 80, top: top2 }, { position: 'absolute', left: 160, top: top2 }, { position: 'absolute', left: 240, top: top2 }, { position: 'absolute', left: 300, top: top2 }]
        }

        return {
            styles: styles,
            styles1: styles1
        }

    }

    //绘画车架上的轮子
    drawTire(param,genre) {

        if (param == null) {
            return
        }
        let styles, styles1;
        let data = this.dealStyle(param, styles, styles1)
        styles = data.styles
        styles1 = data.styles1
        let commonstyle = {
            display: 'flex', flexDirection: 'column', alignItems: 'center'
        }
        return param.map((item, index) => {

            if (item.length === 0) {

            }
            if (item.length === 2) {

                return (
                    <div style={styles[index]} key={index}>

                        <div style={commonstyle}>
                            <div style={{ position: 'relative', top: -11 }}>{(index < param.length - 1) ? (index + 1) + intl.get('txt_qiao') : intl.get('txt_beitai')}</div>
                            <div style={{ position: 'relative', top: 10 }}>
                                <img src={item[1].wear_degree == 'high' ? require('../../assets/report/htirered.png') : item[1].wear_degree == 'low' ? require('../../assets/report/htiregreen.png') : require('../../assets/report/tire_gray_hx.png')} style={{ width: 40, height: 13, position: 'relative', left: item[1].number >= 10 ? 6 : 3 }}></img>
                                <span style={{ zIndex: 12, position: 'relative', right: 19, top: 1 }}>{item[1].number}</span>
                            </div>
                            <div>
                                <img src={require('../../assets/report/axle1.png')} style={{ height: 91, width: 7 }}></img>
                            </div>
                            <div style={{ position: 'relative', top: -10 }}>
                                <img src={item[0].wear_degree == 'high' ? require('../../assets/report/htirered.png') : item[0].wear_degree == 'low' ? require('../../assets/report/htiregreen.png') : require('../../assets/report/tire_gray_hx.png')} style={{ width: 40, height: 13, position: 'relative', left: item[0].number >= 10 ? 6 : 3 }}></img>
                                <span style={{ zIndex: 12, position: 'relative', right: 19, top: 1 }} >{item[0].number}</span>
                            </div>
                        </div>

                    </div>
                )
            }
            if (item.length === 4) {
               if ((intl.options.currentLocale == 'en')&& (genre==='mount')) {
               
                return (<div style={styles1[index]} key={index}>
                    <div style={commonstyle}>
                        <div style={{ position: 'relative', top: 27 }}>{(index + 1) + intl.get('txt_qiao')}</div>
                        <div style={{ position: 'relative', top: 32 }}>
                            <img src={item[3].wear_degree == 'high' ? require('../../assets/report/htirered.png') : item[3].wear_degree == 'low' ? require('../../assets/report/htiregreen.png') : require('../../assets/report/tire_gray_hx.png')} style={{ width: 40, height: 13, position: 'relative', left: item[3].number >= 10 ? 6 : 9 }}></img>
                            <span style={{ zIndex: 12, position: 'relative', right: 19, top: 1 }}>{item[3].number}</span>
                        </div>
                        <div style={{ position: 'relative', top: 24 }}>
                            <img src={item[2].wear_degree == 'high' ? require('../../assets/report/htirered.png') : item[2].wear_degree == 'low' ? require('../../assets/report/htiregreen.png') : require('../../assets/report/tire_gray_hx.png')} style={{ width: 40, height: 13, position: 'relative', left: item[2].number >= 10 ? 6 : 6 }}></img>
                            <span style={{ zIndex: 12, position: 'relative', right: 19, top: 1 }}>{item[2].number}</span>
                        </div>


                        <div>
                            <img src={require('../../assets/report/axle2.png')} style={{ height: 120, width: 7 }}></img>
                        </div>
                        <div style={{ position: 'relative', top: -24 }}>
                            <img src={item[1].wear_degree == 'high' ? require('../../assets/report/htirered.png') : item[1].wear_degree == 'low' ? require('../../assets/report/htiregreen.png') : require('../../assets/report/tire_gray_hx.png')} style={{ width: 40, height: 13, position: 'relative', left: item[1].number >= 10 ? 6 : 6 }}></img>
                            <span style={{ zIndex: 12, position: 'relative', right: 19, top: 1 }}>{item[1].number}</span>
                        </div>
                        <div style={{ position: 'relative', top: -32 }}>
                            <img src={item[0].wear_degree == 'high' ? require('../../assets/report/htirered.png') : item[0].wear_degree == 'low' ? require('../../assets/report/htiregreen.png') : require('../../assets/report/tire_gray_hx.png')} style={{ width: 40, height: 13, position: 'relative', left: item[0].number >= 10 ? 6 : 9 }}></img>
                            <span style={{ zIndex: 12, position: 'relative', right: 19, top: 1 }}>{item[0].number}</span>
                        </div>
                    </div>
                </div>)
                }
                else{
                return (<div style={styles1[index]} key={index}>
                    <div style={commonstyle}>
                        <div style={{ position: 'relative', top: 27 }}>{(index + 1) + intl.get('txt_qiao')}</div>
                        <div style={{ position: 'relative', top: 32 }}>
                            <img src={item[3].wear_degree == 'high' ? require('../../assets/report/htirered.png') : item[3].wear_degree == 'low' ? require('../../assets/report/htiregreen.png') : require('../../assets/report/tire_gray_hx.png')} style={{ width: 40, height: 13, position: 'relative', left: item[3].number >= 10 ? 6 : 3 }}></img>
                            <span style={{ zIndex: 12, position: 'relative', right: 19, top: 1 }}>{item[3].number}</span>
                        </div>
                        <div style={{ position: 'relative', top: 24 }}>
                            <img src={item[2].wear_degree == 'high' ? require('../../assets/report/htirered.png') : item[2].wear_degree == 'low' ? require('../../assets/report/htiregreen.png') : require('../../assets/report/tire_gray_hx.png')} style={{ width: 40, height: 13, position: 'relative', left: item[2].number >= 10 ? 6 : 3 }}></img>
                            <span style={{ zIndex: 12, position: 'relative', right: 19, top: 1 }}>{item[2].number}</span>
                        </div>


                        <div>
                            <img src={require('../../assets/report/axle2.png')} style={{ height: 120, width: 7 }}></img>
                        </div>
                        <div style={{ position: 'relative', top: -24 }}>
                            <img src={item[1].wear_degree == 'high' ? require('../../assets/report/htirered.png') : item[1].wear_degree == 'low' ? require('../../assets/report/htiregreen.png') : require('../../assets/report/tire_gray_hx.png')} style={{ width: 40, height: 13, position: 'relative', left: item[1].number >= 10 ? 6 : 3 }}></img>
                            <span style={{ zIndex: 12, position: 'relative', right: 19, top: 1 }}>{item[1].number}</span>
                        </div>
                        <div style={{ position: 'relative', top: -32 }}>
                            <img src={item[0].wear_degree == 'high' ? require('../../assets/report/htirered.png') : item[0].wear_degree == 'low' ? require('../../assets/report/htiregreen.png') : require('../../assets/report/tire_gray_hx.png')} style={{ width: 40, height: 13, position: 'relative', left: item[0].number >= 10 ? 6 : 3 }}></img>
                            <span style={{ zIndex: 12, position: 'relative', right: 19, top: 1 }}>{item[0].number}</span>
                        </div>
                    </div>
                </div>)
                }
            }
        })
    }




    getTimeShow(device_time) {
        let lang = intl.options.currentLocale
        if (lang !== 'zh') {
            let temptime = device_time.replace("T", " ")
            let timeArr = temptime.split(' ')

            let time1 = timeArr[0].split('-')


            return time1[2] + '/' + time1[1] + '/' + time1[0] + ' ' + timeArr[1]
        } else {

            return device_time.replace("T", " ")
        }

    }

    getQueryString(name) {
        let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.substr(1).match(reg);
        if (r != null) return decodeURI(r[2]); return null;
    }



    getDescribe(describe) {

        if (describe.indexOf("txt_") > -1) {
            let temp = describe.split(";");
            let str = '';
            for (let i = 0; i < temp.length; i++) {
                if (i <= 1 && temp[i].length > 4) {
                    str = str + intl.get(temp[i]);
                }

            }
            return str

        } else {
            return describe;
        }
    }

    returnDescribe(suggestion, describe, item, index) {
        let key1, key2
        if (describe.startsWith('LF')) {
            key1 = describe.substring(0, 2)
            key2 = describe.substring(2, describe.length)
        } else if (describe.startsWith('RF')) {
            key1 = describe.substring(0, 2)
            key2 = describe.substring(2, describe.length)
        } else if (describe.startsWith('LB')) {
            key1 = describe.substring(0, 2)
            key2 = describe.substring(2, describe.length)
        } else if (describe.startsWith('RB')) {
            key1 = describe.substring(0, 2)
            key2 = describe.substring(2, describe.length)
        } else if (describe.startsWith('FF')) {
            key1 = describe.substring(0, 2)
            key2 = describe.substring(2, describe.length)
        } else if (describe.startsWith('BB')) {
            key1 = describe.substring(0, 2)
            key2 = describe.substring(2, describe.length)
        } else {
            key1 = ''
            key2 = describe
        }

        let key1str = key1 ? intl.get(key1) : ''
        let redarrs = ['严重磨损', '嚴重磨損', '异常', '中间', '中間', '外侧', '外側', '羽状', '羽狀', '内侧', '內側', '5年', '装反', '裝反', '两边', '兩邊', '严重外伤', '嚴重外傷', '请检查轮胎磨损情况', '請檢查輪胎磨損情况', '请检查轮胎外观情况', '請檢查輪胎外觀情况']

        let key2str = suggestion.length >= 4 ? intl.get(key2) : this.getDescribe(key2)
        if (!key2str) {
            key2str = this.getDescribe(key2)
        }
        let str = key1str + key2str
        redarrs.map(item => {
            if (key2str.indexOf(item) !== -1) {
                key2str = key2str.replace(new RegExp(item, "g"), '<*>' + item + '<*>')
            }
        })
        let key2Arr = key2str.split('<*>')
        console.log(key2Arr)
        let tempitem = item
        let lang = intl.options.currentLocale
        return (
            <p className='cnt' key={index}>
                <span>{tempitem.title.indexOf("txt_") > -1 ? intl.get(tempitem.title) : tempitem.title}：</span>
                <span className={lang == 'zh' ? 'redspan' : ''}>{key1str} </span>
                {key2Arr.map((item, index) => {
                    let temp = item;

                    if (redarrs.indexOf(temp) !== -1) {
                        return (<span className='redspan' key={index}>{temp}</span>)
                    } else {
                        return (<span key={index}>{temp}</span>)
                    }


                })}
            </p>
        )

    }

    //解析目的：
    getpurposeStr(data) {
        if (data == 'purp_wash') {
            return intl.get('txt_xichemeirong')
        } else if (data == 'purp_alignment') {
            return intl.get('txt_sldw')
        } else if (data == 'purp_replace') {
            return intl.get('txt_guenghuanluntai')
        } else if (data == 'purp_maintain') {
            return intl.get('txt_weixiubaoyang')
        } else {
            return intl.get('txt_qt')
        }
    }

    // 获取检测报告详情
    getRecordDetail() {
        Api.getRecordDetailcar(this.props.match.params.uuid).then(res => {
            if (res.data.code === 0) {
                //  intl.options.currentLocale = res.data.data.report ? res.data.data.report.language ? res.data.data.report.language : 'zh' : 'zh'
                //    this.forceUpdate()
                this.setState({
                    report: res.data.data.report,
                    language: res.data.data.report ? res.data.data.report.language : 'zh'
                });




                //window.postMessage(JSON.stringify(param),'*')
            } else {
                console.log(res.data.message);
            }
        });
    }
}





const usercolors = ['#36B37E', '#FFAD26', '#FF5230']






// WEBPACK FOOTER //
// ./src/views/report/ReportCar.jsx